import styled from 'styled-components';

import { StyledComponent } from '../../types/styledComponent.types';

export const Flag: StyledComponent<'img'> = styled.img`
  max-width: 100%;
`;
